import { EventEmitter } from '../core/EventEmitter';

export type ViewerTheme = 'dark' | 'light';

const STORAGE_KEY = 'ifc-viewer-theme';

function readStoredTheme(): ViewerTheme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export class ThemeController {
  readonly changed = new EventEmitter<ViewerTheme>();
  current: ViewerTheme = readStoredTheme();

  constructor() {
    this.applyDocumentTheme();
  }

  toggle(): void {
    this.current = this.current === 'dark' ? 'light' : 'dark';
    try {
      localStorage.setItem(STORAGE_KEY, this.current);
    } catch {
      // A blocked storage API must not prevent theme switching for this session.
    }
    this.applyDocumentTheme();
    this.changed.emit(this.current);
  }

  private applyDocumentTheme(): void {
    document.documentElement.dataset.theme = this.current;
    document.documentElement.style.colorScheme = this.current;
  }
}


